import React, { useState } from 'react';
import Icon from '../Icon';
import Input from '../Inputs/Input';
import clsx from 'clsx';

interface QuantityInputAttributes {
  className?: string;
  wrapperClassName?: string;
  onChange?: (quantity: number) => void;
  quantity?: number;
  showButtons?: boolean;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  mediumSize: boolean;
}

const QuantityInput = (props: QuantityInputAttributes) => {
  const {
    className = '',
    wrapperClassName = '',
    onChange,
    quantity,
    showButtons = false,
    min,
    max,
    step,
    disabled = false,
    mediumSize = false,
  } = props;

  const [internalValue, setInternalValue] = useState<number | undefined>(
    quantity ?? 1
  );
  const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout>();

  const onInputChanged = (value) => {
    let parsedValue: number | undefined = parseFloat(value);
    setInternalValue(
      Number.isNaN(parsedValue)
        ? undefined
        : parsedValue > 0
        ? parsedValue
        : 1
    );
    if (!parsedValue || parsedValue <= 0) return;

    if (onChange) {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      // Debounce onChange
      setDebounceTimer(
        setTimeout(() => {
          onChange(value);
        }, 350)
      );
    }
  };

  const iconClasses =
    'absolute top-1/2 -translate-y-1/2 cursor-pointer w-4 h-4 color-gray-900 h-full';

  return (
    <div
      className={clsx(
        wrapperClassName,
        'quantity-input',
        'relative flex flex-col'
      )}
    >
      <Input
        className={clsx(
          className,
          'bg-gray-100 text-center !text-lg',
          disabled && 'text-gray-500'
        )}
        type="number"
        value={internalValue ?? ''}
        onChange={(e) => onInputChanged(e.target.value)}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        inputSize={mediumSize ? 'medium' : 'large'}
      />
      {showButtons && (
        <>
          <button
            className={clsx(
              'left-0 right-[70%] w-[30%]',
              internalValue <= 1 || disabled
                ? 'opacity-[0.24]'
                : 'opacity-1',
              iconClasses,
              disabled && 'pointer-events-none'
            )}
            role="button"
            onClick={() => !disabled && onInputChanged(internalValue - 1)}
          >
            <Icon className="" name="minus" />
          </button>
          <button
            className={clsx(
              'left-[70%] right-0 w-[30%]',
              iconClasses,
              disabled && 'pointer-events-none opacity-[0.24]'
            )}
            role="button"
            onClick={() => !disabled && onInputChanged(internalValue + 1)}
          >
            <Icon className="" name="plus" />
          </button>
        </>
      )}
    </div>
  );
};

export default QuantityInput;
